import { useEffect } from 'react'
import axios from 'axios'
import IMG_1 from 'assets/images/customer/cancel_button.png'
import { COMPANY_NAME_KO } from '../../utils/Utils'
import './CustomerMainOld.scss'

/**
 * @file [고객지원]-[고객센터] 1:1 문의하기에 메일보내기 popup 화면
 */
function MailSendPopup({ isMailSendPopup, setIsMailSendPopup }) {
    useEffect(() => {
        //팝업 이외 영역 스크롤 방지
        document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: scroll;
      width: 100%;`
        return () => {
            const scrollY = document.body.style.top
            document.body.style.cssText = ''
            window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)
        }
    }, [])

    //메일 내용 관련 초기화
    const resetInputVal = () => {
        let username = document.getElementById('username')
        let phone = document.getElementById('phone')
        let mail = document.getElementById('mail')
        let question = document.getElementById('question')
        let validation = document.querySelector('input[name=secert]')

        // input값 초기화
        username.value = null
        phone.value = null
        mail.value = null
        question.value = null
        validation.value = null
    }

    //보내기 선택 시
    const handleSubmit = event => {
        event.preventDefault()

        //setIsMailSendPopup(false);

        let submit = false
        let validation = document.querySelector('input[name=secert]')
        // 개인정보 수집 동의 확인 체크
        if (validation.checked) {
            submit = true
        } else {
            submit = false
            alert('개인정보 수집 동의를 확인해주세요.')
            event.preventDefault()
            return
        }

        // 입력 값 저장
        let username = document.getElementById('username')
        let phone = document.getElementById('phone')
        let mail = document.getElementById('mail')
        let question = document.getElementById('question')

        // 입력받은 값 null 체크
        if (username != null && phone != null && mail != null && question != null) {
            let valueName = username.value
            let valueNum = phone.value
            let valueMail = mail.value
            let valueContents = question.value

            /**
             * 이름 검증
             */
            const regName = /^[가-힣]{2,4}$/
            if (valueName.match(regName) != null) {
                submit = true
            } else {
                alert('두글자 이상 한글 이름을 정확히 입력해주세요.')
                event.preventDefault()
                return
            }
            /**
             * 이메일 검증
             */
            const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
            if (valueMail.match(regExp) != null) {
                submit = true
            } else {
                alert(`이메일을 정확히 입력하세요. \nex) customer@bikebank.com`)
                event.preventDefault()
                return
            }
            /**
             * 휴대폰 번호 체크 정규식
             */
            const regPhone = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
            if (valueNum.match(regPhone) != null) {
                submit = true
            } else {
                alert('잘못된 휴대폰 번호입니다. 숫자, - 를 포함한 숫자만 입력하세요.\nex) 010-1234-5678')
                event.preventDefault()
                return
            }

            // Email 전송(내부 API 사용)
            if (submit) {
                axios
                    .post(
                        '/send_mail.php',
                        {
                            to_name: { COMPANY_NAME_KO },
                            to_email: 'customer-service@genstation.kr',
                            from_name: valueName,
                            from_email: valueMail,
                            title: `${COMPANY_NAME_KO} 홈페이지 메일문의`,
                            type: 'TEXT',
                            contents: `문의내용: ${valueContents} \n고객전화번호: ${valueNum}`,
                        },
                        {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Access-Control-Allow-Origin': '*',
                            },
                        },
                    )
                    .then(res => {
                        //console.log(res)
                        alert('문의 메일이 전송 되었습니다.')
                    })
                    .catch(error => {
                        //console.log(error)
                    })
            }
            resetInputVal()
            //모달창 숨기기 추가
            setIsMailSendPopup(false)
            event.preventDefault()
        }
    }

    //닫기 선택 시
    const closeClick = event => {
        event.preventDefault()
        alert('문의 메일 전송을 취소합니다.')
        resetInputVal()
        setIsMailSendPopup(false)
    }
    return (
        <div className={'modal_mail_send ' + (isMailSendPopup ? '' : 'hidden')}>
            <div className="md_overlay" />
            <form className="md_content" id="form" method="post" onSubmit={handleSubmit}>
                <div className="form-box">
                    <button
                        className="cancel_button"
                        style={{ backgroundImage: `url(${IMG_1})` }}
                        onClick={event => closeClick(event)}></button>
                </div>
                <div className="form-title">
                    <h2>메일보내기</h2>
                </div>
                <div className="form-info">
                    <div className="form-name">
                        <label className="name" htmlFor="username">
                            성명
                        </label>
                        <input
                            className="name-input"
                            type="text"
                            id="username"
                            defaultValue=""
                            placeholder="이름을 입력하세요."
                            autoComplete="off"
                        />
                    </div>
                    <div className="form-phone">
                        <label className="phone" htmlFor="phone">
                            휴대폰
                        </label>
                        <input
                            className="phone-input"
                            type="text"
                            id="phone"
                            defaultValue=""
                            placeholder="ex) 010-1234-5678"
                            autoComplete="off"
                        />
                    </div>
                </div>
                <div className="form-mailbox">
                    <label className="email" htmlFor="mail">
                        이메일
                    </label>
                    <input
                        className="email-input"
                        type="text"
                        id="mail"
                        defaultValue=""
                        placeholder="ex) customer@bikebank.com"
                        autoComplete="off"
                    />
                </div>
                <div className="form-content">
                    <label className="contents" htmlFor="question">
                        문의내용
                    </label>
                    <textarea
                        className="contents-input"
                        type="text"
                        id="question"
                        /* value="" */
                        placeholder="문의내용을 입력하세요."
                        autoComplete="off"
                        defaultValue=""
                    />
                </div>
                <div className="form-agree">
                    <div className="agree-title">
                        <a className="title" /* href="{() => false}" */>개인정보 수집 동의</a>
                        <label className="agree-box-name">동의함</label>
                        <input className="check_box" type="checkbox" name="secert" />
                    </div>
                    <div className="agree-text">
                        <a className="text" /*  href="{() => false}" */>
                            개인정보 수집 및 이용 동의서 <br />
                            이와 관련하여 아래와 같이 귀하의 개인정보를 수집 및 이용 내용을 개인정보보호법 제
                            15조(개인정보의 수집 및 이용) 및 통계법 33조(비밀의 보호 등)에 의거하여 안내 드리니 확인하여
                            주시기 바랍니다.
                            <br />
                            <br />- 개인정보의 수집 및 이용 목적 : 고객문의 처리를 위한 연락처 수집
                            <br />- 수집하려는 개인정보의 필수 항목 : 성명, 연락처, 이메일
                            <br />- 개인정보의 보유 및 이용 기간 : 고객문의 처리 후 3개월 이내 폐기
                        </a>
                    </div>
                </div>
                <div className="form-submit">
                    <button className="md_submit">보내기</button>
                </div>
            </form>
        </div>
    )
}

export default MailSendPopup
